import React from 'react';

export const SortUpIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="5"
    height="4"
    viewBox="0 0 5 4"
    fill="none"
    style={{ marginBottom: '2px' }}
  >
    <path
      d="M2.01535 0.513081C2.21551 0.253657 2.60693 0.253657 2.80709 0.513081L4.6831 2.94457C4.93672 3.27328 4.70241 3.75 4.28724 3.75L0.535209 3.75C0.120036 3.75 -0.114274 3.27328 0.13934 2.94457L2.01535 0.513081Z"
      fill={active ? '#2B4956' : '#C6C6C6'}
    />
  </svg>
);
